module.exports = __webpack_public_path__ + "static/img/59-2.3958c14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/59-2.jpg
// module id = ciPk
// module chunks = 0